import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: 'flex',
        width: '100%',
        flexDirection: 'row',
        '& label:first-of-type': {
            marginLeft: 0,
        },
        '& label:last-child': {
            marginRight: 0,
        },
    },
    radioButtonLabel: {
        width: '33.33%',
        borderBottom: `2px solid ${theme.palette.primary.light}`,
        borderTop: `2px solid ${theme.palette.primary.light}`,
        [theme.breakpoints.up('md')]: {
            width: '33.33%',
        },
        position: 'relative',
        cursor: 'pointer',
        flexDirection: 'column',
        justifyContent: 'space-around',
        alignSelf: 'stretch',
        flexShrink: 3,
        flex: 1,
        padding: '15px 0',
        margin: '0px 6px',
        display: 'flex',
        alignItems: 'center',
        textAlign: 'center',
        '& flos-icon .transparent-fill-stroke': {
            stroke: theme.palette.primary.light,
            fill: 'none',
        },
        // Need al this to fixed a weird bug in chrome iphone/IPad
        '& input[type=radio], & input[type=checkbox]': {
            display: 'block',
            position: 'absolute',
            'z-index': 5,
            top: 0,
            left: 0,
            opacity: 0,
            width: '100%',
            height: '100%',
            cursor: 'pointer',
            outline: 'none',
            '-webkit-tap-highlight-color': 'transparent', // get rid of chrome default highlight
        },
        '& span, & flos-icon': {
            pointerEvents: 'none',
        },
        '&:hover': {
            backgroundColor: 'white',
            borderBottom: `2px solid ${theme.palette.primary.dark}`,
            borderTop: `2px solid ${theme.palette.primary.dark}`,
            '& > span': {
                color: theme.palette.primary.dark,
            },
            '& flos-icon .transparent-fill-stroke': {
                stroke: theme.palette.primary.dark,
                fill: 'none',
            },
        },
    },
    radioDisabled: {
        //borderBottom: `2px dotted ${theme.palette.primary.light}`,
        //borderTop: `2px dotted ${theme.palette.primary.light}`,
        color: 'rgba(0, 0, 0, 0.38)',
        backgroundColor: 'transparent',
        cursor: 'not-allowed',
        '&:hover': {
            //borderBottom: `2px dotted ${theme.palette.primary.light}`,
            //borderTop: `2px dotted ${theme.palette.primary.light}`,
            color: 'rgba(0, 0, 0, 0.38)',
            backgroundColor: 'transparent',
            cursor: 'not-allowed',
            '& > span': {
                color: theme.palette.primary.light,
            },
        },
        '& input[type=radio], & input[type=checkbox]': {
            cursor: 'not-allowed',
        },
    },
    radioLabel: {
        color: theme.palette.primary.light,
        fontSize: theme.typography.pxToRem(16),
        fontWeight: 400,
        marginTop: '14px',
        lineHeight: '16px',
        paddingBottom: '3px',
        [theme.breakpoints.up('sm')]: {
            fontSize: theme.typography.pxToRem(18),
            lineHeight: '18px',
        },
    },
    nonIconLabel: {
        marginTop: 0,
        fontSize: theme.typography.pxToRem(18),
        color: `${theme.palette.primary.light}`,
        padding: '12px 0',
    },
    radioButtonLabelSelected: {
        backgroundColor: 'white',
        flex: 1,
        borderBottom: `2px solid ${theme.palette.primary.dark}`,
        borderTop: `2px solid ${theme.palette.primary.dark}`,
        '& > span': {
            color: theme.palette.primary.dark,
        },
    },
    radioButtonLabelError: {
        backgroundColor: 'transparent',
        borderBottom: `2px solid ${theme.palette.error.main}`,
        borderTop: `2px solid ${theme.palette.error.main}`,
        '& > span': {
            color: theme.palette.error.main,
        },
    },
    radioButtonLabelSelect: {
        backgroundColor: 'rgba(34, 54, 96, 1)',
        color: 'white',
        fontSize: theme.typography.pxToRem(20),
        width: '100%',
        textAlign: 'center',
        position: 'absolute',
        bottom: '-30px',
        height: '30px',
        display: 'table',
        fontWeight: 'lighter',
        '& > span': {
            display: 'table-cell',
            verticalAlign: 'middle',
            fontSize: '1.14rem',
            color: 'white',
        },
    },
    iconLeftRight: {
        flexDirection: 'row',
        justifyContent: 'center',

        '& span': {
            marginBottom: 0,
            marginTop: 0,
            paddingBottom: 0,
            paddingTop: 0,
            lineHeight: '1.125rem',
        },
    },
    iconLeft: {
        marginLeft: '0.625rem',
    },
    iconRight: {
        marginRight: '0.625rem',
    },
    slimSideMarginRight: {
        marginRight: '0.115rem',
    },
    slimSideMarginLeft: {
        marginLeft: '0.115rem',
    },
}));
